import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="turbo"
export default class extends Controller {
  initialize() {
    $(this.element).chosen();
  }
}
